import Api from '../Api/Api';
import UserProfile from './UserProfile';
import $ from 'jquery';
import React from 'react';
import 'jquery-mask-plugin';

var AddressController = (function (that) {
  var hasAddress = function (obj) {
    let hasAddress = false;
    if (obj && !$.isEmptyObject(obj)) {
      if (
        obj.hasOwnProperty('street') &&
        obj['street'] !== '' &&
        obj.hasOwnProperty('city') &&
        obj['city'] !== ''
      ) {
        hasAddress = true;
      }
    }
    return hasAddress;
  };

  var getAddrUrl = function (addr) {
    let addressURL = '';
    if (addr && !$.isEmptyObject(addr)) {
      if (addr.hasOwnProperty('street')) {
        addressURL += addr.street;
        if (addr.hasOwnProperty('number')) {
          if (addr.number) {
            addressURL += ' ' + addr.number;
          }
        }
        if (addr.hasOwnProperty('comp')) {
          if (addr.comp) {
            addressURL += ' ' + addr.comp;
          }
        }
        if (addr.hasOwnProperty('zip')) {
          if (addr.zip) {
            addressURL += ', ' + addr.zip;
          }
        }
        if (addr.hasOwnProperty('city')) {
          if (addr.city) {
            addressURL += ', ' + addr.city;
          }
        }
        if (addr.hasOwnProperty('state')) {
          if (addr.state) {
            addressURL += ', ' + addr.state;
          }
        }
      }
    }
    return addressURL;
  };

  var JobAddressFormatter = function (that, value, row) {
    if (value) {
      if (row) {
        if (['REMOTE', 'NO_LOCATION'].includes(row.workplace_mode)) {
          return (
            <span>
              -
              <br />
              {row.country ? AddressController.countryToFlag(row.country) : ''}
            </span>
          );
        }

        let addr = [];

        if (row.address) {
          if (row.address.city) {
            addr.push(row.address.city);
          }
          if (row.address.state) {
            addr.push(row.address.state);
          }
        }

        if (addr.length > 0 && row.country) {
          addr.push(AddressController.countryToFlag(row.country));
        }

        if (addr.length === 0) return null;

        return <span>{addr.join(' ')}</span>;
      } else {
        if (value.length === 2) {
          return <span>{AddressController.countryToFlag(value)}</span>;
        } else if (value) {
          return <span>{value}</span>;
        } else {
          return null;
        }
      }
    } else {
      return null;
    }
  };

  var JobAddressFormatterNew = function (that, row) {
    if (row) {
      const countries = that.props.countries;

      if (row?.address) {
        const address = row.address;
        const city = address.city;
        const state = address.state;
        const country = row.country;

        if (!['REMOTE', 'NO_LOCATION'].includes(row.workplace_mode)) {
          return `${city} ${state}`;
        }
        const countryLabel = countries?.find((countryItem) => countryItem.code === country)?.name;
        const remoteLabel = that.props.intl.formatMessage({
          id: 'JobApplicantList.addressJob_remote'
        });

        return `${remoteLabel} ${countryLabel}`;
      }
    }

    return '';
  };

  var ApplicantAddressFormatter = function (that, value, row, job) {
    if (value) {
      // Display formatted adderss when Hunting or Remote
      if (['REMOTE', 'NO_LOCATION'].includes(job.workplace_mode)) {
        return <small className="text-muted">{value}</small>;
      } else {
        const job = that.state.job;
        return (
          <small className="text-muted">
            {AddressController.addrApplicantToJob(row.address, job.address)}
          </small>
        );
      }
    } else {
      return null;
    }
  };

  var addrApplicantToJob = function (applicant_address, job_address) {
    if (applicant_address) {
      let hood;
      let city = '';
      let state = '';
      let addrInfo = '';
      let hasCity = false;
      let hasState = false;

      if (applicant_address.neiborhood) {
        hood = applicant_address.neiborhood;
      }

      if (job_address && job_address.city && applicant_address.city) {
        if (job_address.city.toUpperCase() !== applicant_address.city.toUpperCase()) {
          city = applicant_address.city;
          hasCity = true;
        }
      }
      if (job_address && job_address.state && applicant_address.state) {
        if (job_address.state.toUpperCase() !== applicant_address.state.toUpperCase()) {
          state = applicant_address.state;
          hasState = true;
        }
      }

      if (hood) {
        addrInfo = hood;
      }
      if (hasCity || hasState) {
        if (hasCity) {
          if (hood) {
            addrInfo = addrInfo + ' (' + city;
          } else {
            addrInfo = city;
          }
        }
        if (hasState) {
          if (hood) {
            addrInfo = addrInfo + '/' + state + ')';
          } else {
            addrInfo = addrInfo + '/' + state;
          }
        } else if (hood) {
          addrInfo = addrInfo + ')';
        }
      }
      return addrInfo;
    } else {
      return null;
    }
  };

  var addrApplicantFull = function (applicant_address, zip) {
    if (applicant_address) {
      let addrInfo = [];

      if (applicant_address.street) {
        addrInfo.push(applicant_address.street);
      }

      if (applicant_address.number) {
        addrInfo.push(applicant_address.number);
      }

      if (applicant_address.complement) {
        addrInfo.push(applicant_address.complement);
      }

      if (applicant_address.neiborhood) {
        addrInfo.push(applicant_address.neiborhood);
      }

      if (applicant_address.city) {
        addrInfo.push(applicant_address.city);
      }

      if (applicant_address.state) {
        addrInfo.push(applicant_address.state);
      }

      if (zip) {
        addrInfo.push(zip);
      }

      return addrInfo.join(', ');
    } else {
      return null;
    }
  };

  var addrApplicantShort = function (applicant_address) {
    if (applicant_address) {
      let addrInfo = [];

      if (applicant_address.city) {
        addrInfo.push(applicant_address.city);
      }

      if (applicant_address.state) {
        addrInfo.push(applicant_address.state);
      }

      return addrInfo.join(', ');
    } else {
      return null;
    }
  };

  // ISO 3166-1 alpha-2
  // ⚠️ No support for IE 11
  var countryToFlag = function (isoCode) {
    if (!isoCode || typeof isoCode !== 'string') {
      return '';
    }

    return typeof String.fromCodePoint !== 'undefined'
      ? isoCode
          .toUpperCase()
          .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
      : isoCode;
  };

  var getCronofyToken = function (cronofy_token_date, cronofy_token_info, cb) {
    const exp = cronofy_token_info.expires_in;
    const current_token = cronofy_token_info.access_token;
    const refresh_token = cronofy_token_info.refresh_token;
    let expireDate = new Date(cronofy_token_date);
    expireDate.setSeconds(new Date().getSeconds() + exp);
    const now = new Date();

    //console.log(expireDate);
    //console.log(now);
    if (expireDate > now) {
      console.log('Cronofy access token still valid');
      return cb(null, current_token);
    } else {
      console.log('Cronofy token needs refresh!');
      let api = new Api();
      let payload = {
        options: {
          grant_type: 'refresh_token',
          refresh_token: refresh_token
        }
      };
      api.post('AccountUsers/cronofy-refresh-access-token', payload, (status, data) => {
        //console.log(data);
        const new_access_token = data.access_token;
        let new_token_info = {
          ...cronofy_token_info,
          ...data
        };
        let upd = {
          cronofy_token_date: new Date(),
          cronofy_token_info: new_token_info
        };
        api.update('AccountUsers', UserProfile.getId(), upd, (status, data) => {
          //console.log(data);
          return cb(null, new_access_token);
        });
      });
    }
  };

  var getMaskedID = function (containerID, idMask) {
    $(`#${containerID}`).mask(idMask);
  };

  var unMaskedID = function (containerID) {
    $(`#${containerID}`).unmask();
  };

  var getMaskedCurrency = function (value, currency) {
    value = value.toString();
    value = value.replace('.', '').replace(',', '').replace(/\D/g, '');

    let locale = 'en-US';
    let splitChar = '.';

    if (currency === 'BRL') {
      locale = 'pt-BR';
      splitChar = ',';
    }

    const options = { minimumFractionDigits: 2 };
    const result = new Intl.NumberFormat(locale, options).format(parseFloat(value) / 100);

    const unformattedValue = parseInt(
      result.split(splitChar)[0].replace('.', '').replace(',', '').replace(/\D/g, '')
    );

    return {
      maskedResult: result,
      integerResult: unformattedValue
    };
  };

  var getMaskedMobilePhone = function (phoneNumber, format) {
    // Default format if no specific format is provided
    const defaultFormat = '(###) ###-####';
    const maskToUse = format || defaultFormat;
    const digitsOnly = String(phoneNumber || '').replace(/\D/g, '');
    const maxDigits = (maskToUse.match(/#/g) || []).length;
    const limitedDigits = maxDigits > 0 ? digitsOnly.slice(0, maxDigits) : digitsOnly;

    let formattedNumber = '';
    let digitIndex = 0;

    // Apply the mask using digit slots (#), not total string length
    for (let i = 0; i < maskToUse.length && digitIndex < limitedDigits.length; i++) {
      if (maskToUse[i] === '#') {
        formattedNumber += limitedDigits[digitIndex];
        digitIndex++;
      } else {
        formattedNumber += maskToUse[i];
        // If the next character in the phone number is the same as the mask character,
        // skip it to avoid duplicates
        if (digitIndex < limitedDigits.length && limitedDigits[digitIndex] === maskToUse[i]) {
          digitIndex++;
        }
      }
    }

    return formattedNumber;
  };

  /**
   * Contagem de slots de dígito na máscara (9 do CSV ou # já normalizado).
   * Sem máscara retorna 0 (sem obrigatoriedade de tamanho).
   */
  var getMobileMaskDigitCount = function (format) {
    if (!format) return 0;

    return (String(format).match(/[9#]/g) || []).length;
  };

  /**
   * Telefone está completo quando a quantidade de dígitos atinge a da máscara do país.
   * Se não houver máscara, não bloqueia.
   */
  var isMobilePhoneComplete = function (phoneNumber, format) {
    const expectedDigits = getMobileMaskDigitCount(format);
    if (expectedDigits === 0) return true;

    const phoneDigits = String(phoneNumber || '').replace(/\D/g, '');
    return phoneDigits.length >= expectedDigits;
  };

  return {
    hasAddress: hasAddress,
    getAddrUrl: getAddrUrl,
    addrApplicantToJob: addrApplicantToJob,
    addrApplicantFull: addrApplicantFull,
    addrApplicantShort: addrApplicantShort,
    countryToFlag: countryToFlag,
    getCronofyToken: getCronofyToken,
    JobAddressFormatter: JobAddressFormatter,
    JobAddressFormatterNew: JobAddressFormatterNew,
    ApplicantAddressFormatter: ApplicantAddressFormatter,
    getMaskedID: getMaskedID,
    getMaskedCurrency: getMaskedCurrency,
    unMaskedID: unMaskedID,
    getMaskedMobilePhone: getMaskedMobilePhone,
    getMobileMaskDigitCount: getMobileMaskDigitCount,
    isMobilePhoneComplete: isMobilePhoneComplete
  };
})();

export default AddressController;
